import {IJsonPatch} from '@mintdata-wsp/thirdparty/jiff/lib/jsonPatch';
import * as patches from './patches';

export function inverse(p:Array<IJsonPatch>)
{
    const pr = [];
    let i, skip;

    for( i = p.length - 1; i >= 0; i -= skip )
        skip = invertOp(pr, p[i], i, p);

    return pr;
}

function invertOp(patch:Array<IJsonPatch>, c, i, context)
{
    const op = patches[c.op];

    return op !== void 0 && typeof op.inverse === 'function'
        ? op.inverse(patch, c, i, context)
        : 1;
}
